var _path, _path2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKeyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 101,
    viewBox: "0 0 101 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 16,
    width: 70,
    height: 72
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M84.1667 16.4898H15.8431V87.602H84.1667V16.4898Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 16,
    width: 70,
    height: 72
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8431 16.4898H84.1667V87.602H15.8431V16.4898Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.798 30.0637L71.1249 24.159C64.8586 17.6368 54.6987 17.6368 48.4325 24.159L46.5886 26.0781C43.4618 29.3326 41.7377 33.5963 41.7315 37.8619C41.7272 40.8083 42.5402 43.7559 44.0249 46.3724L23.3151 68.0157C20.22 71.237 18.5313 75.5798 18.5121 80.0304C18.5007 82.6707 20.581 84.836 23.1178 84.8241C25.7724 84.8118 28.3872 84.1296 30.729 82.8433C32.688 81.7671 34.1683 79.9744 35.0509 77.8598C35.3009 77.2607 35.6621 76.7227 36.1082 76.2598C36.9964 75.3384 38.2478 74.8256 39.5995 74.8239C40.9669 74.8222 42.2708 74.1804 43.1616 73.2398C44.0353 72.317 44.6657 70.9779 44.6674 69.5816C44.6689 68.1718 45.0348 66.7725 45.9235 65.8475C46.8123 64.9225 48.1527 64.5477 49.5072 64.5459C50.8827 64.5442 52.2011 63.8535 53.0928 62.9033C53.9575 61.9818 54.7053 60.3762 55.2975 58.2958C57.7745 59.8185 60.7185 60.778 63.5078 60.7959C67.6477 60.8227 71.7957 58.8891 74.9543 55.6015L76.798 53.6824C83.0645 47.1604 83.0645 36.5859 76.798 30.0637Z",
    stroke: "#001B4D",
    strokeWidth: 4.74,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.5489 32.6011L68.5556 40.9347",
    stroke: "#001B4D",
    strokeWidth: 4.74,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 101,
    height: 101,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyIcon);
export default __webpack_public_path__ + "static/media/KeyIcon.72812ce50d7df32e223d7a54faf74808.svg";
export { ForwardRef as ReactComponent };